const palette = {
  primary: {
    main: "#38512E",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#E5EDC7",
    contrastText: "#000000",
  },
  text: {
    primary: "#000000",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
